module.exports = __webpack_public_path__ + "static/media/arrow.b2f76c99.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow.svg
// module id = 1687
// module chunks = 0